import { From } from '@/data/constant'
import type { AwaitStoreItem } from '@/store/modules/awaitPaibanStore'
import type { BujianStoreItem } from '@/store/modules/bujianStore'

import {
  getAnalyzeBujianData,
  parseAwaitStoreRenderUrl,
  plankAddAwaitStoreFeature,
  plankAddBujianStoreFeature,
} from '.'

export function createAwaitStoreDragStrategy(t: (k: string) => string) {
  return {
    loadErrorText: t('plankLoadErr'),
    async getDragPlank(currentDrag: AwaitStoreItem) {
      if (!currentDrag.render_url) return null
      return parseAwaitStoreRenderUrl(
        currentDrag.render_url,
        currentDrag.from ?? From.BLUEN,
        currentDrag.plankNum
      )
    },
    addStoreFeature(plank: any, currentDrag: AwaitStoreItem) {
      plankAddAwaitStoreFeature(plank, currentDrag)
    },
  }
}

export const bujianStoreDragStrategy = {
  loadErrorText: '补件板件加载失败',
  async getDragPlank(currentDrag: BujianStoreItem) {
    if (currentDrag._preloadedPlank) return currentDrag._preloadedPlank
    if (!currentDrag.render_url) return null
    return getAnalyzeBujianData(currentDrag)
  },
  addStoreFeature(plank: any, currentDrag: BujianStoreItem) {
    plankAddBujianStoreFeature(plank, currentDrag)
  },
  shouldLoadDragPlank(currentDrag: BujianStoreItem) {
    return currentDrag.isDone !== 'done' || !currentDrag.plank
  },
}
